<template lang='pug'>
tr.fp-simple-tree-item(:class="className",ref="simpletreeitem",@click="click")
  td
    .fp-simple-tree-row-heads
      .fp-simple-tree-row-head(
        v-for='n, index in [].constructor(item.level+1)',
        :class='{first: index===0,last: index===item.level, disable: item.hideLevels.indexOf(index)!= -1 }'
      )
    span.content
      i.open-icon.fa.pointer(
        v-if='item.children && item.children.length > 0',
        @click.stop='$emit("toggle")',
        :class="{'fa-plus': !item.open, 'fa-minus': item.open}"
      )
      i.icon(:class='getIcon()')
      span.value(ref='value', v-html='value')

</template>

<script>
  import get from 'lodash/get'

  export default {
    props: {
      isLast: { type: Boolean },
      item: { type: Object },
      root: { type: Object },
      treeId: { type: String },
      options: { type: Object }
    },
    mounted () {
      if (!this.item.open && this.options.isOpen(this.item)) {
        this.item.open = true
        this.$emit('render')
      }
    },
    computed: {
      value () {
        let def = this.options.type[this.item.type]
        if (typeof def.function === 'function') {
          return def.function(this.item)
        }
        return get(this.item, def.target) || '-'
      },
      className () {
        let className = [`fp-simple-tree-item-${this.item.type}`]
        if (this.isLast) className.push('last')
        if (get(this.options, `type.${this.item.type}.draggable`)) className.push('sortable-item')
        if (this.isActive()) className.push('active')
        return className.join(' ')
      }
    },
    methods: {
      click () {
        let def = this.options.type[this.item.type]
        if (def.click) def.click.call({}, this.item)
        else {
          if (this.item.children) this.$emit('toggle')
        }
      },
      isActive () {
        return this.options.isActive(this.item)
      },
      getIcon () {
        if (this.options.type[this.item.type].icons) {
          if (this.item.open) {
            return this.options.type[this.item.type].icons.open
          }
          return this.options.type[this.item.type].icons.close
        }
        return this.options.type[this.item.type].icon
      }
    }
  }
</script>
